"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const IconButton_1 = tslib_1.__importDefault(require("@material-ui/core/IconButton"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const component_mapper_1 = require("@bluebase/component-mapper");
exports.IconButton = component_mapper_1.componentMapper(IconButton_1.default, {
    children: ({ name, size, color }) => react_1.default.createElement(components_1.Icon, { name: name, size: size, color: color }),
    accessibilityLabel: 'accessibilityLabel',
    disabled: 'disabled',
    fullWidth: 'fullWidth',
    name: 'name',
    onClick: 'onPress',
    // size: 'size', // Disabled due to format mismatch
    style: ({ style }) => react_native_1.StyleSheet.flatten(style),
    variant: 'variant',
});
exports.IconButton.defaultProps = components_1.IconButtonDefaultProps;
